import {
  getStorageSession,
  deleteStorageSession,
} from '@/shared/infrastructure/storage/Storage';

export const getSession = () => {
  const token = getStorageSession();

  if (token === null) {
    throw new Error("There's no session storage");
  }

  return token;
};

export const deleteSession = (path: string) => {
  deleteStorageSession();
  window.location.assign(path);
};
